import { rum } from '../utils/rum'

/**
 * Client-side product telemetry flows to AWS RUM only (ADR-105 Decision 3) — the backend
 * ingest (POST /api/analytics/events) is removed. AuthContext calls identify() on auth load
 * and login so RUM events carry user_id/tenant_id; reset() clears them on logout.
 */
class AnalyticsService {
  private userId: number | null = null
  private tenantId: number | null = null

  track(eventName: string, properties: Record<string, unknown> = {}): void {
    try {
      rum?.recordEvent(eventName, { ...properties, user_id: this.userId, tenant_id: this.tenantId })
    } catch {
      // Analytics must never break the app
    }
  }

  identify(userId: number | string | null, tenantId?: number | string | null): void {
    this.userId = userId != null ? Number(userId) : null
    this.tenantId = tenantId != null ? Number(tenantId) : null
  }

  reset(): void {
    this.userId = null
    this.tenantId = null
  }
}

export const analyticsService = new AnalyticsService()
